export enum LangConfig {
    AR = "ar",
    EN = "en"
}
